import React from "react";
import PropTypes from "prop-types";
import closeIcon from "../../../../assets/images/icons/icon_close_outline.svg";

/**
 * Close Modal Button
 */
const CloseButton = ({ onClick }) => (
  <button
    onClick={onClick}
    className="pt-5 pr-5 outline-none bg-transparent border-none"
    data-dismiss="modal"
    type="button"
  >
    <span className="sr-only">Close</span>
    <img alt="close modal" src={closeIcon} />
  </button>
);

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default CloseButton;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/TgModal/CloseButton.jsx